<template>
    <!--<aside class="sidebar-secondary">-->
        <!--<div class="margin-top-xl">-->
            <!--<div class="sidebar-block">-->
                <!--<div class="list-preference">-->
                    <!--<h3>Preference</h3>-->
                    <!--<ul>-->
                        <!--<li><a href="#" class="active"><span class="icon"><i class="icm-blocks"></i></span><span>Icon Menu</span></a></li>-->
                        <!--<li><a href="#"><span class="icon"><i class="icm-list"></i></span><span>List Menu</span></a></li>-->
                    <!--</ul>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
        <!--<div class="sidebar-footer margin-top-xl">-->
            <!--<div class="sidebar-block">-->
                <!--<div class="links-icons between-center">-->
                        <!--<a href="#"><span class="icon"><i class="fa fa-question-circle"></i></span><span>Help</span></a>-->
                        <!--<router-link :to="{ name: 'global-settings.index' }"><span class="icon"><i class="fa fa-cog"></i></span><span>Settings</span></router-link>-->
                <!--</div>-->
                <!--<div class="links margin-top-lg">-->
                    <!--<ul>-->
                        <!--<li><a href="#"><span>Privacy Terms</span></a></li>-->
                        <!--<li><a href="#"><span>Information about us</span></a></li>-->
                    <!--</ul>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
    <!--</aside>-->
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    export default {
        computed: {
            ...mapGetters(['currentUserIsAdmin'])
        },
    }
</script>
